/*
 *  Tags provide way to find facilities with other keywords
 *  than just facility name.
 */

import * as R from 'ramda';
import { langs, translate } from '~/data-utils';

// tags :: (String, [String]) -> [String]
const tags = R.curry((key, langs) => R.chain(
  R.pipe(
    lang => translate(key, lang),
    R.split(/,\s*/)
  ), langs)
);

// getTypeTags :: String -> [String]
export const getTypeTags = R.memoizeWith(R.identity, type => {
  const key = `facility.tags.${type}`;
  return tags(key, langs());
});
